import React, { createContext, useContext, useMemo } from 'react';
import { DateTimeFormatConfigModel } from './dateTimeFormatConfigModel';
import { OptionTypeWithCode } from '../../components/Select/types';

export interface DateTimeFormatContextType {
  dateTimeFormatConfig?: DateTimeFormatConfigModel;
  timezoneOptions: OptionTypeWithCode<string>[];
  loadingTimezones: boolean;
}

export const DateTimeFormatContext = createContext<DateTimeFormatContextType>({
  timezoneOptions: [],
  loadingTimezones: false
});

export const DateTimeFormatProvider: React.FC<React.PropsWithChildren<DateTimeFormatContextType>> = ({
  children,
  dateTimeFormatConfig,
  loadingTimezones,
  timezoneOptions
}) => {
  const value = useMemo(
    () => ({
      dateTimeFormatConfig,
      timezoneOptions,
      loadingTimezones
    }),
    [dateTimeFormatConfig, loadingTimezones, timezoneOptions]
  );

  return <DateTimeFormatContext.Provider value={value}>{children}</DateTimeFormatContext.Provider>;
};

export const useDateTimeFormatContext = () => useContext<DateTimeFormatContextType>(DateTimeFormatContext) || {};
